import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Router } from "@angular/router";

import { map } from "rxjs/operators";
import { PoliciesForm } from "app/interfaces/policies-form.interface";

const systemReportMailtUrlApi = environment.systemReportMailtUrlApi;
const systemPoliciesUrlApi = environment.systemPoliciesUrlApi;
const systemVideoRecordLogsUrlApi = environment.systemVideoRecordLogsUrlApi;

@Injectable()
export class SystemService {
  constructor(private router: Router, private http: HttpClient) {}

  sendMailToAdmin(msg: string) {
    const body = {
      message: msg,
    };
    console.log(body);

    return this.http
      .request("POST", `${systemReportMailtUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  getPolicies() {
    return this.http
      .request("GET", `${systemPoliciesUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getPolicyById(id: number) {
    return this.http
      .request("GET", `${systemPoliciesUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getVideoRecordLogs() {
    return this.http
      .request("GET", `${systemVideoRecordLogsUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  updatePolicyById(id: number, clientModel: PoliciesForm) {
    const body = clientModel;
    return this.http
      .request("PUT", `${systemPoliciesUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }
}
